import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SpsTaskQueueComponent } from "../components/index";
import { SpsTooltipModule } from "./sps-tooltip.module";

@NgModule({
    imports: [CommonModule, SpsTooltipModule],
    declarations: [SpsTaskQueueComponent],
    exports: [SpsTaskQueueComponent]
})
export class SpsTaskQueueModule {}
